import type { NavigateFunction } from 'react-router';

let globalNavigate: NavigateFunction | null = null;

export const setGlobalNavigate = (navigateFn: NavigateFunction): void => {
  globalNavigate = navigateFn;
};

export const navigateTo = (to: string, replace = false, state: unknown = undefined): void => {
  if (globalNavigate) {
    globalNavigate(to, { replace, state });
  } else {
    console.error("Navigation function is not initialized yet.");
  }
};
